var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "case_img" }, [
    _c("img", { staticClass: "large", attrs: { src: _vm.largePic } }),
    _c("img", { staticClass: "small", attrs: { src: _vm.smallPic } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }